/* File: src/pages/GuestPages/EventPage.js */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';
import { useEvent } from '../../contexts/EventContext';
import './EventPage.css';

/**
 * Page d'affichage de l'événement Bright Night (Douala uniquement)
 * VERSION CORRIGÉE - Sans sélection ville
 */
const EventPage = () => {
  const navigate = useNavigate();
  const { eventDetails, loading, error } = useEvent();
  
  // Vérifier que l'utilisateur a passé la vérification d'âge
  useEffect(() => {
    const birthYear = localStorage.getItem('birthYear');
    
    if (!birthYear) {
      navigate('/');
    }
  }, [navigate]);
  
  // ✅ CORRECTION : Redirige vers /ticket-selection
  const handleGetPass = () => {
    console.log('Redirection vers /ticket-selection');
    navigate('/ticket-selection');
  };
  
  const handleAlreadyRegistered = () => {
    navigate('/retrieve-ticket');
  };
  
  const handleBack = () => {
    navigate('/');
  };
  
  /**
   * ✅ CORRECTION : Visuel unique pour Bright Night (pas de logique ville)
   */
  const getEventVisual = () => {
    // Si un visuel est défini dans la base de données, l'utiliser
    if (eventDetails?.visuel) {
      return `/brightnight/assets/images/${eventDetails.visuel}`;
    }
    
    // Sinon, utiliser le visuel Bright Night 2025
	return '/brightnight/assets/images/flyer-bright-night-2025.jpg';
  };
  
  // Formater la date de l'événement
  const formatEventDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const options = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    
    return date.toLocaleDateString('fr-FR', options)
      .replace(/^\w/, c => c.toUpperCase()); // Première lettre en majuscule
  };
  
  // Afficher un message de chargement
  if (loading) {
    return (
      <div className="event-page loading-page">
        <div className="loading-container">
          <img 
            src="/assets/images/guinness-logo.png" 
            alt="Guinness Cameroun"
            className="loading-logo" 
          />
          <div className="spinner"></div>
          <p>Chargement des informations de l'événement...</p>
        </div>
      </div>
    );
  }
  
  // Afficher un message d'erreur
  if (error && !eventDetails) {
    return (
      <div className="event-page error-page">
        <div className="error-container">
          <img 
            src="/assets/images/guinness-logo.png" 
            alt="Guinness Cameroun"
            className="error-logo" 
          />
          <h2>Erreur</h2>
          <p>{error}</p>
          <Button
            variant="guinness"
            onClick={() => navigate('/')}
          >
            Retour à l'accueil
          </Button>
        </div>
      </div>
    );
  }
  
  // Vérifier que l'événement existe
  if (!eventDetails) {
    return (
      <div className="event-page error-page">
        <div className="error-container">
          <img 
            src="/assets/images/guinness-logo.png" 
            alt="Guinness Cameroun"
            className="error-logo" 
          />
          <h2>Aucun événement disponible</h2>
          <p>L'événement Guinness Bright Night n'est pas disponible actuellement.</p>
          <Button
            variant="guinness"
            onClick={() => navigate('/')}
          >
            Retour à l'accueil
          </Button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="event-page">
      <div className="event-container">
        <div className="back-arrow" onClick={handleBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 19L5 12L12 5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <div className="event-content">
          {/* Flyer de l'événement */}
          <div className="event-flyer">
            <img 
              src={getEventVisual()} 
              alt="Guinness Bright Night 2025"
              onError={(e) => {
                // Si l'image n'existe pas, utiliser une image par défaut
                e.target.onerror = null;
                e.target.src = '/assets/images/flyer-bright-night-default.jpg';
              }}
            />
          </div>
          
          {/* Informations de l'événement */}
          <div className="event-info">
            <h2>{eventDetails.event_name || eventDetails.name}</h2>
            <p className="event-date">
              📅 {formatEventDate(eventDetails.event_date || eventDetails.date)}
            </p>
            <p className="event-location">
              📍 {eventDetails.location}
            </p>
            
          </div>
          
          {/* Actions */}
          <div className="event-actions">
            <Button
              variant="guinness"
              size="lg"
              fullWidth
              onClick={handleGetPass}
            >
              OBTENIR MON PASS
            </Button>
            
            <div className="retrieve-ticket-link">
              <button 
                className="text-button"
                onClick={handleAlreadyRegistered}
              >
                Déjà inscrit ? Retrouver mon pass
              </button>
            </div>
          </div>
        </div>
        
        <div className="event-footer">
          <p>
            La consommation d'alcool est réservée aux personnes âgées de plus de 21 ans. 
            L'abus d'alcool est dangereux pour la santé, à consommer avec modération.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventPage;